$(document).ready(function() {

    /* 1 -------------------------------------------------- */

    setTimeout(() => {
        $('#index-section-1 .aos-init').addClass('aos-animate');
    }, 50);

    let owl_1 = $("#index-section-1 .owl-carousel").owlCarousel({
        items: 1,
        nav: false,
        dots: false,
        smartSpeed: 800,
        animateIn: 'fadeIn',
        animateOut: 'fadeOut',
        responsive: {
            0: {
                dots: true
            },
            1280: {
                dots: false
            }
        }
    }).on('changed.owl.carousel', function(event) {

        let current = event.item.index;
        let p = $(event.target).find(".owl-item").eq(current).find('.data');

        if (event.item.index === 0)
            $('#index-section-1 .float-nav .owl-prev').prop('disabled', true);
        else 
            $('#index-section-1 .float-nav .owl-prev').prop('disabled', false);

        if (event.item.index === event.item.count - event.page.size)
            $('#index-section-1 .float-nav .owl-next').prop('disabled', true);
        else
            $('#index-section-1 .float-nav .owl-next').prop('disabled', false);

        $('#index-section-1 .fade-text').css('opacity', '0');

        setTimeout(() => {
            $('#index-section-1 .aos-init').removeClass('aos-animate');
        }, 100);

        setTimeout(() => {
            $('#index-section-1 .data-pretitle').html($(p).data('pretitle'));
            $('#index-section-1 .data-title').html($(p).data('title'));
            $('#index-section-1 .data-button').html($(p).data('button-text'));
            $('#index-section-1 .data-button').attr('href', $(p).data('button-url'));
            $('#index-section-1 [data-url]').attr('data-url', $(p).data('button-url'));
        }, 250);

        setTimeout(() => {
            $('#index-section-1 .fade-text').css('opacity', '1');
            $('#index-section-1 .aos-init').addClass('aos-animate');
        }, 550);

        slick_1.slick('slickGoTo', current);

    });

    $('#index-section-1 .container').on('click', function() {
        window.location.href = $(this).data('url');
    });

    $("#index-section-1").swipe({
        swipeLeft: function (event) {
            event.stopPropagation();

            owl_1.trigger('next.owl.carousel');
        },
        swipeRight: function (event) {
            event.stopPropagation();

            owl_1.trigger('prev.owl.carousel');
        }
    });

    $("#index-section-1 .float-nav .owl-prev").on('click', function(event) {
        event.stopPropagation();

        owl_1.trigger('prev.owl.carousel');
    });
    $("#index-section-1 .float-nav .owl-next").on('click', function(event) {
        event.stopPropagation();

        owl_1.trigger('next.owl.carousel');
    });

    $('#index-section-1 .container').find('.slick-slider').on('click', function(event) {
        event.stopPropagation();
    });

    let slick_1 = $('#index-section-1 .slick-slider').slick({
        vertical: true,
        infinite: false,
        slidesToShow: 1,
        speed: 800,
        arrows : false,
        focusOnSelect: true
    });

    slick_1.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        slick_1.find('.slick-slide').css('opacity', '0');
        slick_1.find('.slick-slide').eq(nextSlide).css('opacity', '1');

        if (nextSlide == 0) {
            slick_1.find('.slick-slide').eq(nextSlide + 1).css('opacity', '.5');
            slick_1.find('.slick-slide').eq(nextSlide + 2).css('opacity', '.5');
        }
        if (nextSlide > 0 && !(slick.nextSlide >= slick.slideCount - slick.options.slidesToShow)) {
            slick_1.find('.slick-slide').eq(nextSlide - 1).css('opacity', '.5');
            slick_1.find('.slick-slide').eq(nextSlide + 1).css('opacity', '.5');
        }
        if (slick.nextSlide >= slick.slideCount - slick.options.slidesToShow) {
            slick_1.find('.slick-slide').eq(nextSlide - 1).css('opacity', '.5');
            slick_1.find('.slick-slide').eq(nextSlide - 2).css('opacity', '.5');
        }
        
        owl_1.trigger('to.owl.carousel', [nextSlide]);
    });

    let slick_1_H = parseInt(slick_1.find('.slick-slide').css('margin-bottom').replace('px', '')) + slick_1.find('.slick-slide').outerHeight();
    let slick_1_nH = slick_1.slick('getSlick').slideCount > 3 ? slick_1.slick('getSlick').slideCount - 3 : 0;
    slick_1_nH = slick_1_nH * slick_1_H;
    slick_1.css('bottom', `-${slick_1_nH}px`);

    /* 2 -------------------------------------------------- */

    let owl_2 = $("#index-section-2 .owl-carousel").owlCarousel({
        items: 3,
        nav: false,
        dots: false,
        margin: 30,
        stagePadding: 50,
        smartSpeed: 800,
        responsive: {
            0 : {
                items: 1,
                margin: 20,
                stagePadding: 20,
            },
            375 : {
                items: 1,
                margin: 20,
                stagePadding: 20,
            },
            390 : {
                items: 1,
                margin: 20,
                stagePadding: 20,
            },
            414 : {
                items: 1,
                margin: 20,
                stagePadding: 20,
            },
            428 : {
                items: 1,
                margin: 20,
                stagePadding: 20,
            },
            480 : {
                items: 1,
                margin: 20,
                stagePadding: 30,
            },
            768 : {
                items: 2,
                margin: 30,
                stagePadding: 40,
            },
            800 : {
                items: 2,
                margin: 30,
                stagePadding: 40,
            },
            1024 : {
                items: 2,
                margin: 30,
                stagePadding: 40,
            },
            1280 : {
                items: 3,
                margin: 20,
                stagePadding: 20,
            },
            1366 : {
                items: 3,
                margin: 20,
                stagePadding: 20,
            },
            1440 : {
                items: 3,
                margin: 30,
                stagePadding: 30,
            },
            1536 : {
                items: 3,
                margin: 30,
                stagePadding: 40,
            },
            1600 : {
                items: 3,
                margin: 30,
                stagePadding: 40,
            },
            1920 : {
                items: 3,
                margin: 30,
                stagePadding: 50,
            },
            2560 : {
                items: 3,
                margin: 30,
                stagePadding: 50,
            }
        }
    }).on('changed.owl.carousel', function(event) {
        if (event.item.index === 0)
            $('#index-section-2 .side-nav .owl-prev').prop('disabled', true);
        else 
            $('#index-section-2 .side-nav .owl-prev').prop('disabled', false);

        if (event.item.index === event.item.count - event.page.size)
            $('#index-section-2 .side-nav .owl-next').prop('disabled', true);
        else
            $('#index-section-2 .side-nav .owl-next').prop('disabled', false);
    });

    $("#index-section-2 .side-nav .owl-prev").on('click', function() {
        owl_2.trigger('prev.owl.carousel');
    });
    $("#index-section-2 .side-nav .owl-next").on('click', function() {
        owl_2.trigger('next.owl.carousel');
    });

    /* 4 -------------------------------------------------- */

    let owl_4 = $("#index-section-4 .owl-carousel").owlCarousel({
        items: 5,
        slideBy: 5,
        nav: false,
        dots: false,
        margin: 20,
        smartSpeed: 500,
        stagePadding: 0,
        responsive: {
            0 : {
                items: 1,
                slideBy: 1,
                margin: 20,
                stagePadding: 30,
            },
            375 : {
                items: 1,
                slideBy: 1,
                margin: 20,
                stagePadding: 30,
            },
            390 : {
                items: 1,
                slideBy: 1,
                margin: 20,
                stagePadding: 30,
            },
            414 : {
                items: 1,
                slideBy: 1,
                margin: 20,
                stagePadding: 30,
            },
            428 : {
                items: 1,
                slideBy: 1,
                margin: 20,
                stagePadding: 30,
            },
            480 : {
                items: 1,
                slideBy: 1,
                margin: 20,
                stagePadding: 30,
            },
            768 : {
                items: 2,
                slideBy: 2,
                margin: 20,
                stagePadding: 30,
            },
            800 : {
                items: 2,
                slideBy: 2,
                margin: 20,
                stagePadding: 30,
            },
            1024 : {
                items: 2,
                slideBy: 2,
                margin: 20,
                stagePadding: 30,
            },
            1280 : {
                items: 4,
                slideBy: 4,
                margin: 20,
                stagePadding: 0,
            },
            1366 : {
                items: 4,
                slideBy: 4,
                margin: 20,
                stagePadding: 0,
            },
            1440 : {
                items: 4,
                slideBy: 4,
                margin: 20,
                stagePadding: 0,
            },
            1536 : {
                items: 5,
                slideBy: 5,
                margin: 20,
                stagePadding: 0,
            },
            1600 : {
                items: 5,
                slideBy: 5,
                margin: 20,
                stagePadding: 0,
            },
            1920 : {
                items: 5,
                slideBy: 5,
                margin: 20,
                stagePadding: 0,
            },
            2560 : {
                items: 5,
                slideBy: 5,
                margin: 20,
                stagePadding: 0,
            }
        }
    }).on('changed.owl.carousel', function(event) {
        if (event.item.index === 0)
            $('#index-section-4 .side-nav .owl-prev').prop('disabled', true);
        else 
            $('#index-section-4 .side-nav .owl-prev').prop('disabled', false);

        if (event.item.index === event.item.count - event.page.size)
            $('#index-section-4 .side-nav .owl-next').prop('disabled', true);
        else
            $('#index-section-4 .side-nav .owl-next').prop('disabled', false);
    });

    $("#index-section-4 .side-nav .owl-prev").on('click', function() {
        owl_4.trigger('prev.owl.carousel');
    });
    $("#index-section-4 .side-nav .owl-next").on('click', function() {
        owl_4.trigger('next.owl.carousel');
    });

    /* 5 -------------------------------------------------- */

    let owl_5 = $("#index-section-5 .owl-carousel").owlCarousel({
        items: 5,
        slideBy: 5,
        nav: false,
        dots: false,
        margin: 20,
        smartSpeed: 500,
        stagePadding: 0,
        responsive: {
            0 : {
                items: 1,
                slideBy: 1,
                margin: 20,
                stagePadding: 30,
            },
            375 : {
                items: 1,
                slideBy: 1,
                margin: 20,
                stagePadding: 30,
            },
            390 : {
                items: 1,
                slideBy: 1,
                margin: 20,
                stagePadding: 30,
            },
            414 : {
                items: 1,
                slideBy: 1,
                margin: 20,
                stagePadding: 30,
            },
            428 : {
                items: 1,
                slideBy: 1,
                margin: 20,
                stagePadding: 30,
            },
            480 : {
                items: 1,
                slideBy: 1,
                margin: 20,
                stagePadding: 30,
            },
            768 : {
                items: 2,
                slideBy: 2,
                margin: 20,
                stagePadding: 30,
            },
            800 : {
                items: 2,
                slideBy: 2,
                margin: 20,
                stagePadding: 30,
            },
            1024 : {
                items: 2,
                slideBy: 2,
                margin: 20,
                stagePadding: 30,
            },
            1280 : {
                items: 4,
                slideBy: 4,
                margin: 20,
                stagePadding: 0,
            },
            1366 : {
                items: 4,
                slideBy: 4,
                margin: 20,
                stagePadding: 0,
            },
            1440 : {
                items: 4,
                slideBy: 4,
                margin: 20,
                stagePadding: 0,
            },
            1536 : {
                items: 5,
                slideBy: 5,
                margin: 20,
                stagePadding: 0,
            },
            1600 : {
                items: 5,
                slideBy: 5,
                margin: 20,
                stagePadding: 0,
            },
            1920 : {
                items: 5,
                slideBy: 5,
                margin: 20,
                stagePadding: 0,
            },
            2560 : {
                items: 5,
                slideBy: 5,
                margin: 20,
                stagePadding: 0,
            }
        }
    }).on('changed.owl.carousel', function(event) {
        if (event.item.index === 0)
            $('#index-section-5 .side-nav .owl-prev').prop('disabled', true);
        else 
            $('#index-section-5 .side-nav .owl-prev').prop('disabled', false);

        if (event.item.index === event.item.count - event.page.size)
            $('#index-section-5 .side-nav .owl-next').prop('disabled', true);
        else
            $('#index-section-5 .side-nav .owl-next').prop('disabled', false);
    });

    $("#index-section-5 .side-nav .owl-prev").on('click', function() {
        owl_5.trigger('prev.owl.carousel');
    });
    $("#index-section-5 .side-nav .owl-next").on('click', function() {
        owl_5.trigger('next.owl.carousel');
    });

    /* 6 -------------------------------------------------- */

    let owl_6 = $("#index-section-6 .owl-carousel").owlCarousel({
        items: 5,
        slideBy: 5,
        nav: false,
        dots: false,
        margin: 20,
        smartSpeed: 500,
        stagePadding: 0,
        responsive: {
            0 : {
                items: 1,
                slideBy: 1,
                margin: 20,
                stagePadding: 30,
            },
            375 : {
                items: 1,
                slideBy: 1,
                margin: 20,
                stagePadding: 30,
            },
            390 : {
                items: 1,
                slideBy: 1,
                margin: 20,
                stagePadding: 30,
            },
            414 : {
                items: 1,
                slideBy: 1,
                margin: 20,
                stagePadding: 30,
            },
            428 : {
                items: 1,
                slideBy: 1,
                margin: 20,
                stagePadding: 30,
            },
            480 : {
                items: 1,
                slideBy: 1,
                margin: 20,
                stagePadding: 30,
            },
            768 : {
                items: 2,
                slideBy: 2,
                margin: 20,
                stagePadding: 30,
            },
            800 : {
                items: 2,
                slideBy: 2,
                margin: 20,
                stagePadding: 30,
            },
            1024 : {
                items: 2,
                slideBy: 2,
                margin: 20,
                stagePadding: 30,
            },
            1280 : {
                items: 4,
                slideBy: 4,
                margin: 20,
                stagePadding: 0,
            },
            1366 : {
                items: 4,
                slideBy: 4,
                margin: 20,
                stagePadding: 0,
            },
            1440 : {
                items: 4,
                slideBy: 4,
                margin: 20,
                stagePadding: 0,
            },
            1536 : {
                items: 5,
                slideBy: 5,
                margin: 20,
                stagePadding: 0,
            },
            1600 : {
                items: 5,
                slideBy: 5,
                margin: 20,
                stagePadding: 0,
            },
            1920 : {
                items: 5,
                slideBy: 5,
                margin: 20,
                stagePadding: 0,
            },
            2560 : {
                items: 5,
                slideBy: 5,
                margin: 20,
                stagePadding: 0,
            }
        }
    }).on('changed.owl.carousel', function(event) {
        if (event.item.index === 0)
            $('#index-section-6 .side-nav .owl-prev').prop('disabled', true);
        else 
            $('#index-section-6 .side-nav .owl-prev').prop('disabled', false);

        if (event.item.index === event.item.count - event.page.size)
            $('#index-section-6 .side-nav .owl-next').prop('disabled', true);
        else
            $('#index-section-6 .side-nav .owl-next').prop('disabled', false);
    });

    $("#index-section-6 .side-nav .owl-prev").on('click', function() {
        owl_6.trigger('prev.owl.carousel');
    });
    $("#index-section-6 .side-nav .owl-next").on('click', function() {
        owl_6.trigger('next.owl.carousel');
    });

    /* 7 -------------------------------------------------- */

    let owl_7 = $("#index-section-7 .owl-carousel").owlCarousel({
        items: 3,
        nav: false,
        dots: false,
        margin: 20,
        stagePadding: 50,
        smartSpeed: 800,
        responsive: {
            0 : {
                items: 1,
                margin: 20,
                stagePadding: 20,
            },
            375 : {
                items: 1,
                margin: 20,
                stagePadding: 20,
            },
            390 : {
                items: 1,
                margin: 20,
                stagePadding: 20,
            },
            414 : {
                items: 1,
                margin: 20,
                stagePadding: 20,
            },
            428 : {
                items: 1,
                margin: 20,
                stagePadding: 20,
            },
            480 : {
                items: 1,
                margin: 20,
                stagePadding: 30,
            },
            768 : {
                items: 2,
                margin: 20,
                stagePadding: 40,
            },
            800 : {
                items: 2,
                margin: 20,
                stagePadding: 40,
            },
            1024 : {
                items: 2,
                margin: 20,
                stagePadding: 40,
            },
            1280 : {
                items: 3,
                margin: 20,
                stagePadding: 20,
            },
            1366 : {
                items: 3,
                margin: 20,
                stagePadding: 30,
            },
            1440 : {
                items: 3,
                margin: 20,
                stagePadding: 40,
            },
            1536 : {
                items: 3,
                margin: 20,
                stagePadding: 50,
            },
            1600 : {
                items: 3,
                margin: 20,
                stagePadding: 50,
            },
            1920 : {
                items: 3,
                margin: 20,
                stagePadding: 50,
            },
            2560 : {
                items: 3,
                margin: 20,
                stagePadding: 50,
            }
        }
    }).on('changed.owl.carousel', function(event) {
        if (event.item.index === 0)
            $('#index-section-7 .side-nav .owl-prev').prop('disabled', true);
        else 
            $('#index-section-7 .side-nav .owl-prev').prop('disabled', false);

        if (event.item.index === event.item.count - event.page.size)
            $('#index-section-7 .side-nav .owl-next').prop('disabled', true);
        else
            $('#index-section-7 .side-nav .owl-next').prop('disabled', false);
    });

    $("#index-section-7 .side-nav .owl-prev").on('click', function() {
        owl_7.trigger('prev.owl.carousel');
    });
    $("#index-section-7 .side-nav .owl-next").on('click', function() {
        owl_7.trigger('next.owl.carousel');
    });

});

$(window).scroll(function() {

    $element4 = $('#index-section-4 .collection-banner');
    if (visiblePercent($element4) > 0) {
        if (!$element4.hasClass('active'))
            $element4.addClass('active');
    }
    else {
        if ($element4.hasClass('active'))
            $element4.removeClass('active');
    }

    $element5 = $('#index-section-5 .collection-banner');
    if (visiblePercent($element5) > 0) {
        if (!$element5.hasClass('active'))
            $element5.addClass('active');
    }
    else {
        if ($element5.hasClass('active'))
            $element5.removeClass('active');
    }

    $element6 = $('#index-section-6 .collection-banner');
    if (visiblePercent($element6) > 0) {
        if (!$element6.hasClass('active'))
            $element6.addClass('active');
    }
    else {
        if ($element6.hasClass('active'))
            $element6.removeClass('active');
    }

});

$('#index-section-3 .grid-item').on('click', function() {
    window.location.href = $(this).data('url');
});